import { useEffect } from 'react';

export const useCanvasClip = ({ stage, clipOutline, canvasPosition, canvasSize }) => {
  useEffect(() => {
    if (!stage) return;
    const canvasLayer = stage.findOne('#canvas');
    if (!canvasLayer) return;

    if (clipOutline) {
      canvasLayer.clip({
        x: canvasPosition.x,
        y: canvasPosition.y,
        width: canvasSize.width,
        height: canvasSize.height,
      });
    } else {
      canvasLayer.clip(null);
    }

    const outlineLayer = stage.findOne('#outlineLayer');
    if (outlineLayer) {
      outlineLayer.visible(true);
    }
    stage.draw();
  }, [clipOutline]);

  useEffect(() => {
    if (!stage) return;
    const canvasLayer = stage.findOne('#canvas');
    if (!canvasLayer) return;
    const canvasBg = stage.findOne('#canvas_bg');
    if (!canvasBg) return;

    canvasBg.setAttrs({
      x: canvasPosition.x,
      y: canvasPosition.y,
      width: canvasSize.width,
      height: canvasSize.height,
    });

    if (clipOutline) {
      canvasLayer.clip({
        x: canvasPosition.x,
        y: canvasPosition.y,
        width: canvasSize.width,
        height: canvasSize.height,
      });
    } else {
      canvasLayer.clip(null);
    }

    const outlineBg = stage.findOne('#outline_bg');
    if (outlineBg) {
      outlineBg.setAttrs({
        x: canvasPosition.x,
        y: canvasPosition.y,
        width: canvasSize.width,
        height: canvasSize.height,
      });
    }

    stage.draw();
  }, [stage, canvasSize, clipOutline, canvasPosition]);
};
